export default __webpack_public_path__ + "static/media/dumyImage.2260d301.svg";